import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate, UtilsString } from '@pit/core';
import { IDtoShipmentProcess, ProductionSystemTransferState, ShipmentDeliveryType, ShipmentProcessState } from '../interfaces/dto.shipment.process.interface';
import { DtoShipmentReturnCode } from './dto.shipment.return.code';
import { IDtoShipmentReturnCode } from '../interfaces/dto.shipment.return.code.interface';
import { DtoShipmentProcessRecipient } from './dto.shipment.process.recipient';
import { IDtoShipmentProcessRecipient } from '../interfaces/dto.shipment.process.recipient.interface';

// @dynamic
@JsonObject('DtoShipmentProcess')
export class DtoShipmentProcess extends ModelEntity implements IDtoShipmentProcess {

    constructor(initValues: Partial<IDtoShipmentProcess> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('externalShipmentId', String, true)
    public externalShipmentId?: string = null;

    @JsonProperty('shipmentId', Number, true)
    public shipmentId?: number = null;

    @JsonProperty('timestamp', UtilsJsonConverterDate, true)
    public timestamp?: Date = null;

    @JsonProperty('userName', String, true)
    public userName?: string = null;

    @JsonProperty('deliveryType', Number, true)
    public deliveryType?: ShipmentDeliveryType = ShipmentDeliveryType.None;

    @JsonProperty('processState', Number, true)
    public processState?: ShipmentProcessState = ShipmentProcessState.InDelivery;

    @JsonProperty('isSyncedToServer', Boolean, true)
    public isSyncedToServer?: boolean = false;

    @JsonProperty('latitude', Number, true)
    public latitude?: number = null;

    @JsonProperty('longitude', Number, true)
    public longitude?: number = null;

    @JsonProperty('shipmentPhoto', String, true)
    public shipmentPhoto?: string = null;

    @JsonProperty('productionSystemTransferState', Number, true)
    public productionSystemTransferState?: ProductionSystemTransferState = ProductionSystemTransferState.Internal;

    @JsonProperty('productionSystemTransferPlannedTime', UtilsJsonConverterDate, true)
    public productionSystemTransferPlannedTime?: Date = null;

    @JsonProperty('recipient', DtoShipmentProcessRecipient, true)
    public recipient?: IDtoShipmentProcessRecipient = null;

    @JsonProperty('returnCode', DtoShipmentReturnCode, true)
    public returnCode?: IDtoShipmentReturnCode = null;

    public get isFinished(): boolean {
        return ((this.processState === ShipmentProcessState.Completed) || (this.processState === ShipmentProcessState.Returned) || (this.processState == ShipmentProcessState.DeleteFromDevice));
    }

    public get isOpen(): boolean {
        return (this.isFinished === false);
    }

    public get processStateDescription(): string {
        let result: string = null;

        switch (this.processState) {
            case ShipmentProcessState.AssignedToPostman: {
                result = 'Übergabe an Zusteller/in';
                break;
            }
            case ShipmentProcessState.InDelivery: {
                result = 'In Zustellung';
                break;
            }
            case ShipmentProcessState.Completed: {
                switch (this.deliveryType) {
                    case ShipmentDeliveryType.DepositToDepot: {
                        result = 'Niedergelegt im Depot';
                        break;
                    }
                    case ShipmentDeliveryType.LetterBox: {
                        result = 'Zugestellt in Briefkasten';
                        break;
                    }
                    case ShipmentDeliveryType.ThirdParty: {
                        result = 'Zugestellt bei dritter Person';
                        break;
                    }
                    case ShipmentDeliveryType.Recipient: {
                        result = 'Zugestellt bei Empfänger/in';
                        break;
                    }
                }
                break;
            }
            case ShipmentProcessState.Returned: {
                try {
                    result = UtilsString.stringFormat('{0} ({1})', this.returnCode.description, this.returnCode.code);
                } catch {
                    result = 'Rückgabecode nicht bekannt';
                }
                break;
            }
            case ShipmentProcessState.ReturnedToDepot: {
                result = 'Rückgabe an Depot';
                break;
            }
        }

        return result;
    }

}
